import React from 'react';
import PropTypes from 'prop-types';

import {Autosuggest} from '../../fragments/forms';

import Reference from '../../../models/reference';

import API from './api';
import fetchPubmedSuggestion from './pubmed-suggestion';

const unicodeCloud = '\u2601\ufe0f';

export default class ReferenceSearchBox extends React.Component {

  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    reference: PropTypes.object,
  };

  constructor() {
    super(...arguments);
    this.state = {
      suggestions: [],
      searchKeyword: '',
      readOnly: false,
    };
  }

  componentDidUpdate(prevProps) {
    const currReference = this.props.reference;
    const prevReference = prevProps.reference;
    if (!currReference || !prevReference) {
      return;
    }
    if (currReference.uuid !== prevReference.uuid) {
      this.setState({
        suggestions: [],
        searchKeyword: '',
      });
    }
  }

  async getSuggestions(searchKeyword) {
    if (searchKeyword === '') {
      return [];
    }
    const {viewer: {references}} = await API({reference: searchKeyword});
    let suggestions = references.edges.map(({node}) => {
      node.loadFrom = 'HIVDB';
      return node;
    });

    if (suggestions.length === 0) {
      const pubmedSuggestion = await fetchPubmedSuggestion(searchKeyword);
      if (pubmedSuggestion) {
        suggestions.push(pubmedSuggestion);
      }
    }

    return suggestions;
  }

  renderSuggestion({id, author, title, refYear}) {
    const isNew = !id;
    return <div>
      {isNew ? `(${unicodeCloud} PUBMED) ` : '(HIVDB) '}
      <strong>{author}</strong> ({refYear}), {title}
    </div>;
  }

  getSuggestionValue(selected) {
    const {author, refYear} = selected;
    if (author && refYear) {
      return `${author} (${refYear})`;
    } else {
      return '';
    }
  }

  async handleSuggestionsFetchRequested() {
  }

  handleSuggestionSelected(e, {suggestion, suggestionValue}) {
    e && e.preventDefault();
    const selected = new Reference(suggestion);
    const {onSelect} = this.props;
    onSelect(selected);
    this.setState({
      searchKeyword: suggestionValue
    });
  }

  handleInputPropsChange(e, {newValue, method}) {
    if (method === 'click') {
      return;
    }
    const searchKeyword = newValue || '';
    this.setState({
      searchKeyword,
      suggestions: [],
    });
  }

  async handleInputPropsKeyDown(e) {
    if (e.key === 'Enter') {
      const {searchKeyword} = this.state;
      if (!searchKeyword) {
        const {onSelect} = this.props;
        onSelect(new Reference());
      } else {
        const suggestions = await this.getSuggestions(searchKeyword.trim());
        this.setState({
          suggestions
        });
      }
    }
  }

  render() {
    const {
      readOnly,
      searchKeyword,
      suggestions
    } = this.state;

    return (
      <Autosuggest
       readOnly={readOnly}
       suggestions={suggestions}
       onSuggestionSelected={
         this.handleSuggestionSelected.bind(this)}
       focusInputOnSuggestionClick={
         false}
       getSuggestionValue={
         this.getSuggestionValue.bind(this)}
       renderSuggestion={
         this.renderSuggestion.bind(this)}
       onSuggestionsFetchRequested={
         this.handleSuggestionsFetchRequested.bind(this)}
       onSuggestionsClearRequested={
         () => {}}
       inputProps={{
         placeholder: 'Search PMID or Author name in HIVDB',
         value: searchKeyword,
         onChange: this.handleInputPropsChange.bind(this),
         onKeyDown: this.handleInputPropsKeyDown.bind(this),
       }}
       />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-searchbox.js